import * as React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Header from './Header';
import Footer from './Footer';
import { Seo } from './seo.js';
import '../styles/styles.css';

export default function Layout({
  location,
  children,
  title = false,
  description = false,
  image = false,
  path = false,
  ogType = false,
}) {
  const data = useStaticQuery(graphql`
    query GetSiteTitle {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

  const meta = data?.site?.siteMetada ?? {};

  return (
    <>
      <Seo
        title={title}
        description={description}
        image={image}
        path={path}
        ogType={ogType}
      />
      <Header location={location} />
      <main className='content'>{children}</main>
      <Footer />
    </>
  );
}
